import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/popup_error.svg'


const _withScopeId = n => (_pushScopeId("data-v-6c4cc710"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component popup" }
const _hoisted_2 = { class: "popup-box contents__box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "회차 당 3번 이상의 반코마이신"),
  /*#__PURE__*/_createElementVNode("h3", null, "투여 정보가 입력되지 않은 경우"),
  /*#__PURE__*/_createElementVNode("h3", null, "예측 결과가 정확하지 않을 수 있습니다.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("button", {
        class: "confirm-btn button__blue",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closePopup()))
      }, "확인")
    ])
  ]))
}